import { render, staticRenderFns } from "./inspectionTemplate.vue?vue&type=template&id=3a574ff0&"
import script from "./inspectionTemplate.vue?vue&type=script&lang=ts&"
export * from "./inspectionTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionTemplate.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports